"use strict";

class RemoveParameterizationDialogCtrl {
    constructor($mdDialog, locals) {
        this.$mdDialog = $mdDialog;
        this.locals = locals;
        this.locals.title = "O que você deseja excluir?";
        this.locals.width = "600px";
    }
    $onInit() {}
    onClose() {
        this.$mdDialog.cancel();
    }
    onRemoveParametrization() {
        this.$mdDialog.hide({
            removeParametrization: true
        });
    }
    onRemoveAccountsPlan() {
        this.$mdDialog.hide({
            removeAccountsPlan: true
        });
    }
}

angular.module("nucont.shared").controller("RemoveParameterizationDialogCtrl", [
    "$mdDialog",
    "locals",
    RemoveParameterizationDialogCtrl
]);
